import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
	XThemeForm,
	XThemeContainer,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeRadio,
	XThemeSelect,
	XThemeTag,
} from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import { PlusOutlined, DownOutlined } from '@ant-design/icons';
import moment from 'moment';
import { XButtonImg, XCardsTransparentTabs } from '../Manage/ManageStyle';
import {
	Radio,
	Input,
	Button,
	Row,
	Col,
	InputNumber,
	notification,
	Card,
	Result,
	Space,
} from 'antd';

import { useNavigate, Link } from 'react-router-dom';
import {
	getReimbursementsApi,
	getReimbursementsReset,
} from '../../actions/getReimbursementsAction';
import {
	caseStatuses,
	dateFilters,
	reimbursementStatuses,
} from '../../utils/constants';
import {
	toTitleCase,
	checkModulePermissions,
	urlPagination,
	truncateString,
} from '../../utils/helper';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import {
	getHospitalDropdownApi,
	getHospitalDropdownReset,
} from '../../actions/getHospitalDropdownAction';

import DataTable from '../../components/DataTable/DataTable';
import CaseSearch from '../../components/CaseSearch/CaseSearch';
import { filterByLabel, handleInputChange } from '../../utils/formFunctions';
import { Title } from '../Login/LoginStyle';
import Header from '../../components/Header/Header';
import {
	getInsuranceDropdownApi,
	getInsuranceDropdownReset,
} from '../../actions/getInsuranceDropdownAction';
import {
	getOrganizationsApi,
	getOrganizationsReset,
} from '../../actions/getOrganizationsAction';
import { getRegionsApi } from '../../actions/getRegionsAction';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';
const { TextArea } = Input;

const Reimbursements = (props) => {
	const {
		getReimbursements,
		getReimbursementsReset,
		getReimbursementsState,
		getStateDropdownState,
		getStateDropdown,
		getHospitalDropdown,
		getHospitalDropdownState,
		getInsuranceDropdown,
		getRegions,
		getRegionsState,
		getOrganizations,
		getOrganizationsState,
	} = props;

	const navigate = useNavigate();
	const defaultFilters = {
		search: '',
		for_page: 'reimbursements',
		page: 1,
		sort: 'claim_amount_updated_at',
		sortDirection: 'descend',
		claim_amount_updated_at: 'all',
		hospital: '',
		status: '',
		insurance_company: '',
		limit: 10,
	};
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const [searchOptions, setSearchOptions] = useState([]);
	const [form] = XThemeForm.useForm();
	const [form2] = XThemeForm.useForm();

	const [modalOpen, setModalOpen] = useState([false, '']);
	const [formData, setFormData] = useState({
		successful_claim_commission_criteria: 'percentage',
		successful_claim_commission_fixed_value: null,
		successful_claim_commission_percentage_value: null,
		rejected_claim_commission_criteria: 'percentage',
		rejected_claim_commission_fixed_value: null,
		rejected_claim_commission_percentage_value: null,
	});
	const [open, setOpen] = useState(false);
	const [insuranceCompanies, setInsuranceCompanies] = useState([]);
	const [pagination, setPagination] = useState(1);

	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};

	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('reimbursements').authorized &&
			getReimbursements({
				...updatedFilters,
				for_page: 'reimbursements',
			});
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	const columns = [
		{
			title: 'Case ID',
			dataIndex: 'case_id',
			fixed: 'left',
			width: 150,
			render: (case_id) => (
				<Link to={`${case_id[2]}/${case_id[0]}`}>{case_id[1]}</Link>
			),
		},
		{
			title: 'Patient ID',
			dataIndex: 'mrn',
			fixed: 'left',
			width: 150,

			render: (mrnId) => (
				<Link to={`${mrnId[2]}/${mrnId[0]}`}>{mrnId[1]}</Link>
			),
		},
		{
			title: 'Case Name',
			dataIndex: 'patient_name',
			fixed: 'left',
			width: 200,

			render: (nameId) => (
				<Link to={`${nameId[2]}/${nameId[0]}`}>
					{truncateString(nameId[1], 25)}
				</Link>
			),
		},
		{
			title: 'Insurance Company',
			dataIndex: 'insurance_company',
			width: 300,

			render: (insurance_company) => <>{insurance_company}</>,
		},
		{
			title: 'Hospital',

			dataIndex: 'hospital',
			width: 200,

			render: (hospital) => <>{hospital}</>,
		},
		{
			title: 'Case Amount',
			dataIndex: 'case_amount',
			width: 200,

			render: (case_amount) => <>{case_amount}</>,
		},
		{
			title: 'Claim Amount',
			dataIndex: 'claim_amount',
			width: 200,
			render: (claim_amount) => <>{claim_amount}</>,
		},
		{
			title: 'Claimed At',
			dataIndex: 'claimed_at',
			width: 200,
			render: (claimed_at) => <>{claimed_at}</>,
		},
		{
			title: 'Reimbursement',
			dataIndex: 'reimbursement',
			width: 200,
			render: (reimbursement) => <>{reimbursement}</>,
		},
		{
			title: 'Payment Delay (days)',
			dataIndex: 'payment_delay',
			width: 200,
			render: (payment_delay) => <>{payment_delay}</>,
		},
		{
			title: 'Interest',
			dataIndex: 'interest_amount',
			width: 200,
			render: (interest_amount) => <>{interest_amount}</>,
		},
		{
			title: 'Reimbursed At',
			dataIndex: 'reimbursed_at',
			width: 200,
			render: (reimbursed_at) => <>{reimbursed_at}</>,
		},
	];

	// use effects

	useEffect(() => {
		if (getReimbursementsState.apiState === 'success') {
			if (getReimbursementsState.data.list.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getReimbursementsState.data.total_count);
				getReimbursementsState.data.list.map((item, index) => {
					updatedSearchOptions.push({ value: item.patient_name });
					updatedData.push({
						key: item._id,
						case_id: [item._id, item.case_id, '/reimbursements'],
						mrn: [item._id, item.mrn, '/reimbursements'],
						patient_name: [
							item._id,
							item.patient_name,
							'/reimbursements',
						],
						insurance_company: item.insurance_company[0]
							? item.insurance_company[0].name
							: '-',
						hospital: item.hospital[0]
							? item.hospital[0].name
							: '-',
						case_amount: item.case_amount
							? '$' + item.case_amount
							: '-',
						claim_amount: item.claim_amount
							? '$' + item.claim_amount
							: '-',
						claimed_at: item.claim_amount_updated_at ? (
							<div className="showDate">
								{moment(item.claim_amount_updated_at).format(
									'DD-MM-YYYY',
								)}
							</div>
						) : (
							'-'
						),
						interest_amount: item.interest_amount
							? '$' + item.interest_amount
							: '-',
						reimbursement: item.is_claim_amount_settled ? (
							<>
								<XThemeTag className={'successful'}>
									{toTitleCase('successful')}
								</XThemeTag>
							</>
						) : (
							<>
								<XThemeTag className={'pending'}>
									{toTitleCase('Pending')}
								</XThemeTag>
							</>
						),
						payment_delay: item.payment_delay
							? item.payment_delay
							: '-',
						reimbursed_at: item.reimbursed_at ? (
							<div className="showDate">
								{moment(item.reimbursed_at).format(
									'DD-MM-YYYY',
								)}
							</div>
						) : (
							'-'
						),
						statusMobile: item.is_claim_amount_settled
							? 'successful'
							: 'pending',
					});
				});
				setSearchOptions(updatedSearchOptions);
				setTableData(updatedData);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getReimbursementsState]);

	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Reimbursements" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile headerTag="reimbursements" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				{checkModulePermissions('reimbursements').authorized ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									Reimbursements
								</XTheme2MainTitle>
								<XTheme2Para1>
									View and manage reimbursements
								</XTheme2Para1>
							</Col>
						</Row>

						<XTheme2InnerCard
							className="mb-3"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<CaseSearch
									filters={[
										<XThemeForm.Item
											name="status"
											colon={false}
											label="Status"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="status"
												defaultValue={
													filters.status
														? filters.status
														: null
												}
											>
												<Row>
													{reimbursementStatuses.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="hospital"
											label="Hospital"
											colon={false}
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												placeholder="Select Hospital"
												name="hospital"
												allowClear
												className="noBorderRadius"
												showSearch={true}
												defaultValue={
													filters.hospital
														? filters.hospital
														: null
												}
												onFocus={() => {
													getHospitalDropdown();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getHospitalDropdown({
															search,
														});
													} else if (
														search.length === 0
													) {
														getHospitalDropdown();
													}
												}}
												onClear={() => {
													setFilters({
														...filters,
														hospital: '',
													});
												}}
												filterOption={filterByLabel}
												options={
													getHospitalDropdownState.apiState ===
														'success' &&
													getHospitalDropdownState
														.data.hospitals
														?.length > 0 &&
													getHospitalDropdownState.data.hospitals.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
															};
														},
													)
												}
												onSelect={(value) => {
													setFilters({
														...filters,
														hospital: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="insurance_company"
											label="Insurance Company"
											colon={false}
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												placeholder="Select Insurance Company"
												name="insurance_company"
												allowClear
												className="noBorderRadius"
												showSearch={true}
												defaultValue={
													filters.insurance_company
														? filters.insurance_company
														: null
												}
												onFocus={() => {
													getInsuranceDropdown();
												}}
												onSearch={(search) => {
													if (search.length >= 3) {
														getInsuranceDropdown({
															search,
														});
													} else if (
														search.length === 0
													) {
														getInsuranceDropdown();
													}
												}}
												onClear={() => {
													setFilters({
														...filters,
														insurance_company: '',
													});
												}}
												filterOption={filterByLabel}
												options={
													insuranceCompanies.length >
														0 &&
													insuranceCompanies.map(
														(itm) => {
															return {
																label: itm.name,
																value: itm._id,
															};
														},
													)
												}
												onSelect={(value) => {
													setFilters({
														...filters,
														insurance_company:
															value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="claim_amount_updated_at"
											colon={false}
											label="Claimed At"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="claim_amount_updated_at"
												defaultValue={
													filters.claim_amount_updated_at
														? filters.claim_amount_updated_at
														: null
												}
											>
												<Row>
													{dateFilters.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
									]}
									onClose={onClose}
									open={open}
									applyFilters={applyFilters}
									form={form2}
									clearFilters={clearFilters}
								/>
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col xs={16} sm={16} md={6} lg={4}>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Cases
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="d-none d-md-block"
									>
										<Space>
											<XTheme2InputText
												size="large"
												allowClear
												placeholder="Search for Cases"
												defaultValue={
													filters.search
														? filters.search
														: null
												}
												onChange={(v) => {
													if (v.target.value === '') {
														urlPagination(
															filters,
															'search',
															'',
														);
														setFilters({
															...filters,
															search: '',
														});
													} else {
														setFilters({
															...filters,
															search: v.target
																.value,
														});
													}
												}}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														const searchValue =
															filters.search
																? filters.search
																: '';
														if (searchValue) {
															urlPagination(
																filters,
																'search',
																searchValue,
															);
															setFilters({
																...filters,
																search: searchValue,
															});
														}
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													// Trigger search when the button is clicked
													const searchValue =
														filters.search
															? filters.search
															: '';
													if (searchValue) {
														urlPagination(
															filters,
															'search',
															searchValue,
														);
														setFilters({
															...filters,
															search: searchValue,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
									<Col
										xs={8}
										sm={8}
										md={6}
										lg={8}
										className="text-end"
									>
										<XTheme2Button
											className="noBackground borderColor"
											shape="circle"
											size="large"
											onClick={() => showDrawer()}
											icon={
												<img
													src="/images/theme-filter-icon.svg"
													alt="filter"
												/>
											}
										/>
									</Col>
								</Row>
							</div>
							<DataTable
								tableData={tableData}
								columns={columns}
								totalRecords={totalRecords}
								setFilters={setFilters}
								filters={filters}
								state={getReimbursementsState.apiState}
								setPagination={setPagination}
								page={'reimbursements'}
							/>
						</XTheme2InnerCard>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getReimbursementsState: state.getReimbursements,
	getStateDropdownState: state.getStateDropdown,
	getHospitalDropdownState: state.getHospitalDropdown,
	getInsuranceDropdownState: state.getInsuranceDropdown,
	getRegionsState: state.getRegions,
	getOrganizationsState: state.getOrganizations,
});

const mapDispatchToProps = (dispatch) => ({
	getReimbursements: (params) => dispatch(getReimbursementsApi(params)),
	getReimbursementsReset: () => dispatch(getReimbursementsReset()),
	getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
	getHospitalDropdown: (params) => dispatch(getHospitalDropdownApi(params)),
	getHospitalDropdownReset: () => dispatch(getHospitalDropdownReset()),
	getInsuranceDropdown: (params) => dispatch(getInsuranceDropdownApi(params)),
	getInsuranceDropdownReset: () => dispatch(getInsuranceDropdownReset()),
	getRegions: (params) => dispatch(getRegionsApi(params)),
	getOrganizations: (data) => dispatch(getOrganizationsApi(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reimbursements);
